<template>
  <div @click="vote" class="rate-button">
    <div :class="`rate-button--back rate-button-${direction ? 'up' : 'down'}`" style="transform: scale(1);">
      <div :class="`rate-button--thumbs rate-button--thumbs-${voteBusy ? 'animated' : ''}`">
        <div class="rate-button--thumbs-dir">
          <svg :style="`transform: scale(${scale})`" width="39" height="37" viewBox="0 0 39 37">
            <path transform="translate(0, 16)" d="M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"></path>
            <path transform="translate(11, 0)" d="M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

export default {
  name: 'RateButton',
  props: ['direction'],
  computed: mapGetters({
    voteCounter: 'voteCounter',
    voteBusy: 'voteBusy',
    tempRefs: 'tempRefs',
    personCurrent: 'personCurrent',
    refs: 'refs',
  }),
  data() {
    return {
      scale: 1,
    };
  },
  mounted() {
    document.body.addEventListener('mousemove', this.mouseMove);
    document.body.addEventListener('touchmove', this.mouseMove);
  },
  beforeDestroy() {
    document.body.removeEventListener('mousemove', this.mouseMove);
    document.body.removeEventListener('touchmove', this.mouseMove);
  },
  methods: {
    mouseMove(e) {
      const middle = (window.innerWidth / 2);
      const distance = this.direction ? e.pageX - middle : middle - e.pageX;
      let scale = 1 + (Math.floor(distance) / window.innerWidth);
      if (scale > 1.3) scale = 1.3;
      this.scale = scale;
    },
    vote() {
      const val = this.direction ? 500 : 100;
      this.$store.commit(types.VOTE_BUSY, true);
      this.$store.commit(types.TEMP_REF, {
        ref: this.refs.results[this.voteCounter],
        value: val,
      });
      setTimeout(() => {
        this.$store.commit(types.VOTE_COUNTER, val);
        if (this.voteCounter >= this.refs.results.length) {
          this.$store.dispatch('voteRefs');
          this.$store.dispatch('updateFacebookOpenGraph', this.personCurrent.id);
          this.$router.push(`/accounts/${this.personCurrent.id}/`);
        }
      }, 500);
    },
  },
};
</script>

<style>
.rate-button{
  &-up{
    background: linear-gradient(180deg,#9be022,#16b110);
    right: 0;
  }
  &-down{
    background: linear-gradient(180deg,#eb5e66,#be151f 98.56%);
    left: 0;
    .rate-button--thumbs-dir{
      transform: rotate(180deg);
      direction: inline-block;
    }
  }
  &--back{
    transition: all .3s ease-in-out;
    text-align: center;
    z-index: 99;
    position: fixed;
    cursor: pointer;
    height: 100%;
    min-width: 50px;
    width: 5vw;
    opacity: 1;
    border: 0;
    top: 0;
    /*&:hover{
      .rate-button--thumbs{
        transform: scale(1.2)!important;
      }
    }*/
  }
  &--thumbs{
    transition: all .2s ease-in-out;
    transform: scale(1);
    opacity: 1;
    position: fixed;
    height: 30px;
    min-width: 50px;
    width: 5vw;
    top: 50%;
    &-animated{
      transform: scale(1.5);
      opacity: 0;
    }
  }

  svg{
    width: 30px;
    fill: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// Button.vue?194d707a